<template>
    <modal
        :show="show"
        body-classes="p-0"
        modal-classes="modal-lg"
        :container-classes="$style.container"
        @update:show="$emit('update:show', $event)"
    >
        <card class="mb-0 card-form">
            <template slot="header">
                <h2 class="modal-title">
                    Request Change to #{{ deliveryRequest.id }}
                </h2>
            </template>
            <ValidationObserver v-slot="{ invalid, validate, pristine }">
                <form
                    ref="form"
                    class="mt-3"
                    autocomplete="off"
                    @submit.prevent="validate().then(submitChange)"
                >
                    <div class="row">
                        <div class="col-6">
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Delivery Date"
                                rules="required"
                            >
                                <base-input
                                    name="deliveryDate"
                                    type="date"
                                    label="Desired Delivery Date"
                                    :error="errors[0]"
                                >
                                    <el-date-picker
                                        v-model="update.deliveryDate"
                                        :picker-options="{
                                            disabledDate: isDeliveryDateInvalid,
                                        }"
                                        format="MM/dd/yyyy"
                                        type="date"
                                        placeholder="Select delivery date"
                                    />
                                </base-input>
                            </ValidationProvider>
                        </div>
                        <div class="col-6">
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Delivery Window"
                                rules="required"
                            >
                                <label>Desired Delivery Window</label>
                                <div class="form-group">
                                    <el-select
                                        v-model="update.deliveryWindow"
                                        class="select-primary"
                                        placeholder="Select delivery time"
                                    >
                                        <el-option
                                            v-for="option in deliveryWindowOptions"
                                            :key="option.value"
                                            class="select-primary"
                                            :label="option.label"
                                            :value="option.value"
                                        />
                                    </el-select>
                                    <label class="error">{{ errors[0] }}</label>
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-12">
                        <ValidationProvider name="Notes">
                            <base-input name="notes" label="Notes">
                                <textarea
                                    v-model="update.notes"
                                    v-focus
                                    style="max-height: unset"
                                    class="form-control"
                                    rows="3"
                                />
                            </base-input>
                        </ValidationProvider>
                    </div>
                    <div :class="$style.actions">
                        <base-button
                            type="default"
                            class="btn-fill"
                            @click="$emit('update:show', false)"
                        >
                            Cancel
                        </base-button>
                        <base-button
                            id="submitChange"
                            :disabled="invalid || pristine"
                            native-type="submit"
                            type="primary"
                            class="btn-fill"
                        >
                            Submit Change
                        </base-button>
                    </div>
                </form>
            </ValidationObserver>
        </card>
    </modal>
</template>

<script>
import { DatePicker } from "element-ui";
import moment from "moment-timezone";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Modal } from "src/components/UI";
import vSelect from "vue-select";

export default {
    name: "DeliveryChangeRequestModal",
    components: {
        [DatePicker.name]: DatePicker,
        ValidationProvider,
        ValidationObserver,
        Modal,
        vSelect,
    },
    props: {
        deliveryRequest: {
            type: Object,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            update: {},
            deliveryWindowOptions: [
                { value: "Morning", label: "9AM - 11AM" },
                { value: "Midday", label: "11AM - 1PM" },
                { value: "Afternoon", label: "1PM - 3PM" },
                { value: "Any", label: "Any" },
            ],
        };
    },
    watch: {
        show: {
            immediate: true,
            handler(visible) {
                if (visible) this.update = {};
            },
        },
    },
    methods: {
        isDeliveryDateInvalid(date) {
            const fortyEightHoursFromNow = moment().add(48, "hours");
            const threePMHour = 15;
            const compareDate = moment(date).hour(threePMHour);
            return fortyEightHoursFromNow > compareDate;
        },
        async submitChange() {
            this.update.id = this.deliveryRequest.id;
            this.update.customerID = this.deliveryRequest.customer.id;
            // eliminate timezone info
            this.update.deliveryDate = this.update.deliveryDate.toDateString();
            this.update.designerIDS =
                this.deliveryRequest.deliveryRequestDetails.map(
                    (i) => i.designer?.id,
                );
            this.$emit("submitChangeRequest", this.update);
            this.$refs.form.reset();
        },
    },
};
</script>

<style module lang="scss">
.container {
    z-index: 1090;
}
.actions {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
}
.actions .right > * {
    margin-right: 10px;
    margin-left: 10px;
}
</style>
